<template>
  <v-app>
    <v-container>
      <!-- Navigation Bar -->
      <v-row>
        <v-col cols="12">
          <NavBar pageTitle="Messages" />
        </v-col>
      </v-row>

      <!-- Page Title -->
      <v-row class="mt-5">
        <v-col cols="12" class="text-center">
          <h1 class="page-title">Inbox</h1>
        </v-col>
      </v-row>

      <!-- Tab Navigation -->
      <v-row class="tab-buttons mt-3">
        <v-col cols="12" class="text-center">
          <v-btn
            class="tab-btn"
            :class="{ active: $route.name === 'Inbox' }"
            @click="$router.push('/messages/inbox')"
          >
            Inbox
          </v-btn>
          <v-btn
            class="tab-btn"
            :class="{ active: $route.name === 'Sent' }"
            @click="$router.push('/messages/sent')"
          >
            Sent
          </v-btn>
          <v-btn
            class="tab-btn"
            :class="{ active: $route.name === 'Trash' }"
            @click="$router.push('/messages/trash')"
          >
            Trash
          </v-btn>
          <v-btn
            class="tab-btn"
            :class="{ active: $route.name === 'Archive' }"
            @click="$router.push('/messages/archive')"
          >
            Archive
          </v-btn>
        </v-col>
      </v-row>

      <!-- Scrollable Message List -->
      <v-row class="mt-3">
        <v-col cols="12" class="message-list-container">
          <v-list>
            <v-list-item
              v-for="(email, index) in inboxEmails"
              :key="index"
              class="email-item"
              @click="$router.push(`/messages/${email.id}`)"
            >
              <div class="email-container">
                <!-- Blue Dot for Unread Emails -->
                <div v-if="!email.read" class="unread-dot"></div>

                <!-- Email Content -->
                <div class="email-content">
                  <v-list-item-title>
                    <span class="sender">
                      <strong>{{ email.sender }}</strong>
                    </span>
                    <span class="timestamp">{{ email.timestamp }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <span class="subject">{{ email.subject }}</span> -
                    <span class="preview">{{ email.preview }}</span>
                  </v-list-item-subtitle>
                </div>
              </div>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>

    <!-- Footer Bar -->
    <MENDFooter/>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import MENDFooter from "./MENDFooter.vue";

export default {
  name: "InboxPage",
  components: {
    NavBar,
    MENDFooter
  },
  data() {
    return {
      inboxEmails: [
        {
          id: 1,
          sender: "Therapy Center",
          subject: "Follow-Up: Mindfulness Session",
          preview: "Thank you for attending the mindfulness session...",
          timestamp: "14:26",
          read: false,
        },
        {
          id: 2,
          sender: "Therapist Support",
          subject: "Weekly Check-In Reminder",
          preview: "Just checking in on your progress this week...",
          timestamp: "12:27",
          read: false,
        },
        {
          id: 3,
          sender: "Mental Health Team",
          subject: "Appointment Confirmation",
          preview: "Your therapy session is scheduled for tomorrow at...",
          timestamp: "10:25",
          read: true,
        },
        {
          id: 4,
          sender: "Therapy Tools",
          subject: "Tips for Managing Stress",
          preview: "Here are some effective stress management tools...",
          timestamp: "09:53",
          read: true,
        },
      ],
    };
  },
};
</script>

<style scoped>
.page-title {
  color: #08b6aa;
  font-weight: bold;
  text-align: center;
  margin-bottom: 16px;
  margin-top: 32px;
}

/* Tab Buttons */
.tab-buttons .v-btn {
  color: #08b6aa;
  border-color: #08b6aa;
  background-color: white;
  margin: 8px;
  transition: background-color 0.3s, color 0.3s;
}

.tab-buttons .v-btn:hover {
  background-color: #ff6d44;
  color: white;
}

.tab-buttons .v-btn.active {
  background-color: #08b6aa;
  color: white;
  border-color: #08b6aa;
}

.message-list-container {
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #ffffff;
}

.email-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.3s ease;
}

.email-item:hover {
  background-color: #f9f9f9;
}

.email-container {
  display: flex;
  align-items: center;
  gap: 12px;
}

.unread-dot {
  width: 10px;
  height: 10px;
  background-color: #08b6aa;
  border-radius: 50%;
  flex-shrink: 0;
}

.email-content {
  display: flex;
  flex-direction: column;
}

.sender {
  font-size: 16px;
  color: #333;
}

.timestamp {
  float: right;
  color: #aaa;
  font-size: 14px;
}

.subject {
  font-weight: bold;
  color: #333;
}

.preview {
  font-size: 14px;
  color: #555;
}

/* Footer Bar */
.footer-bar {
  height: 40px; /* Thin Footer */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.footer-content {
  font-size: 14px;
  color: white;
  text-align: center;
}

.footer-link {
  color: white;
  text-decoration: none;
  margin: 0 4px;
}

.footer-link:hover {
  text-decoration: underline;
}
</style>
